import { CButton, CCol, CContainer, CFormLabel, CFormTextarea, CModal, CNav, CNavItem, CNavLink, CTabContent, CFormCheck, CTabPane, CModalBody, CModalFooter, CModalHeader, CModalTitle, CRow, CTooltip } from '@coreui/react'
import React, { useEffect, useState } from 'react'
import Graytextarea from '../Graytextarea'
import { Info, Plus } from 'lucide-react'
import SaveExtra from '../../services/general/saveExtraData.api'
import { CAccordion, CAccordionBody, CAccordionHeader, CAccordionItem } from '@coreui/react'
import AddOrders from '../../views/dashboard/AddOrders'
import Editor, { Toolbar } from 'react-simple-wysiwyg'
import BulletTextArea from '../BulletTextArea'

const questionFields = [
  { key: 'rollLeftAndRight', label: 'Roll left and right' },
  { key: 'sitToLying', label: 'Sit to lying' },
  { key: 'lyingToSittingOnSideOfBed', label: 'Lying to sitting on side of bed' },
  { key: 'sitToStand', label: 'Sit to stand' },
  { key: 'chairToBedTransfer', label: 'Chair to bed transfer' },
  { key: 'toiletTransfer', label: 'Toilet transfer' },
  { key: 'walk10Feet', label: 'Walk 10 feet' },
  { key: 'ambulatoryAids', label: 'Ambulatory aids' },
]

const FallsAssessment = ({ noteStructureRef, diagnosisName, isAllotedToProvider, saveTreatsShell, noteID, noteRefTrigger, showDataIfNoteIsFollowUp = true, patientID, showTreatmentAsAccordion }) => {
  const [assessmentSuggestions, setAssessmentSuggestions] = useState('')
  const [mobilityData, setMobilityData] = useState(null)
  const [total, setTotal] = useState([])
  const [morseScoreDate, setMorseScoreDate] = useState('')
  const [labsImaging, setLabsImaging] = useState('')
  const [poa, setPoa] = useState('')
  const [freeType, setFreeType] = useState('')
  const [visible, setVisible] = useState(false)
  const [orderModalVisible, setOrderModalVisible] = useState(false)
  const [activeKey, setActiveKey] = useState(1)
  const [activeKey2, setActiveKey2] = useState(1)
  const [assessmentFinalValue, setAssessmentFinalValue] = useState('')

  const [sugesstionsAssessmentsList, setSugesstionsAssessmentsList] = useState([]) //putting the fetched data
  const [selectedAssessmentSuggestionStrings, setSelectedAssessmentSuggestionString] = useState([])
  const [selectedPlansSuggestionsStrings, setSelectedPlanSuggestionsStrings] = useState([])
  const [selectedPlanSuggestion, setSelectedPlanSuggestion] = useState([])

  const [showEditHtml, setShowEditHtml] = useState(false)
  const [tempHtmlContent, setTempHtmlContent] = useState('')

  useEffect(() => {
    const assessment = noteStructureRef.current?.assessment?.[diagnosisName]
    if (!assessment) return

    const { MobilityAssessment, POA, LabImaging, FreeType, MorseScore, assessmentSuggestions } = assessment

    if (MobilityAssessment?.assessment) {
      setMobilityData(MobilityAssessment.assessment)
    }

    if (assessmentSuggestions) {
      setAssessmentSuggestions(assessmentSuggestions)
    }

    if (POA) {
      setPoa(POA)
    }

    if (LabImaging) {
      setLabsImaging(LabImaging)
    }

    if (FreeType) {
      setFreeType(FreeType)
      setTempFreeType(FreeType)
    }

    if (MorseScore) {
      setMorseScoreDate(MorseScore.date || '')
      if (MorseScore.score) {
        setTotal(MorseScore.score[6] || 0)
      }
    }
  }, [noteRefTrigger, diagnosisName])

  const handleLabsChanges = (value) => {
    setLabsImaging(value)
    noteStructureRef.current = {
      ...noteStructureRef.current,
      assessment: {
        ...noteStructureRef.current.assessment,
        [diagnosisName]: {
          ...noteStructureRef.current.assessment[diagnosisName],
          LabImaging: value,
        },
      },
    }
    ;``
  }

  // Freetype center
  const [tempFreeType, setTempFreeType] = useState('')
  const [visibleModalTempFreeType, setVisibleModalTempFreeType] = useState(false)
  // const handleFreeTypeChanges = async(value) => {
  //     setFreeType(value);
  //     noteStructureRef.current = {
  //         ...noteStructureRef.current,
  //         assessment: {
  //             ...noteStructureRef.current.assessment,
  //             [diagnosisName]: {
  //                 ...noteStructureRef.current.assessment[diagnosisName],
  //                 FreeType: value
  //             }
  //         }
  //     };
  //     // await saveTreatsShell(false)
  // }
  const handleSaveFreetype = async () => {
    setVisibleModalTempFreeType(false)
    noteStructureRef.current = {
      ...noteStructureRef.current,
      assessment: {
        ...noteStructureRef.current.assessment,
        [diagnosisName]: {
          ...noteStructureRef.current.assessment[diagnosisName],
          FreeType: tempFreeType,
        },
      },
    }
    setFreeType(tempFreeType)
    await saveTreatsShell(false)
  }
  // Freetype center

  // useEffect(() => {
  //     noteStructureRef.current = {
  //         ...noteStructureRef.current,
  //         assessment: {
  //             ...noteStructureRef.current.assessment,
  //             [diagnosisName]: {
  //                 ...noteStructureRef.current.assessment[diagnosisName],
  //                 assessmentSuggestions: assessmentSuggestions,
  //             }
  //         }

  //     };
  // }, [assessmentSuggestions])

  useEffect(() => {
    const assessmentSuggestionAdded = noteStructureRef?.current?.assessment?.[diagnosisName]?.assessmentSuggestions
    const planSuggestionAdded = noteStructureRef?.current?.plans?.[diagnosisName]?.planSuggestion

    if (assessmentSuggestionAdded) {
      const splittedArrayAssessmentSuggestion = assessmentSuggestionAdded.split('\n').filter(Boolean)
      if (splittedArrayAssessmentSuggestion.length > 0) {
        setSelectedAssessmentSuggestionString(splittedArrayAssessmentSuggestion)

        // Recursively search and collect matching plan structures
        const collectedPlanSuggestions = []

        const searchAccordions = (accordions) => {
          for (const accordion of accordions) {
            const suggestions = accordion?.suggestions?.suggestionName || []

            for (const suggestion of suggestions) {
              if (splittedArrayAssessmentSuggestion.includes(suggestion.name)) {
                const planSuggestions = accordion?.suggestions?.planSuggestions || []

                const matchingPlan = planSuggestions.find((plan) => plan.name === suggestion.name)

                const flatSuggestionNames = matchingPlan?.accordions?.flatMap((acc) => acc?.suggestions?.suggestionName || []) || []

                const itemStructure = {
                  name: suggestion.name,
                  suggestions: flatSuggestionNames,
                }

                collectedPlanSuggestions.push(itemStructure)
              }
            }

            // Recurse children
            if (accordion.children && accordion.children.length > 0) {
              searchAccordions(accordion.children)
            }
          }
        }

        searchAccordions(sugesstionsAssessmentsList || [])
        setSelectedPlanSuggestion(collectedPlanSuggestions)
      }
    }

    if (planSuggestionAdded) {
      const splittedArrayPlan = planSuggestionAdded.split('\n').filter(Boolean)
      setSelectedPlanSuggestionsStrings(splittedArrayPlan)
    }
  }, [noteStructureRef.current, sugesstionsAssessmentsList])

  const getAllDiagnosisDifferential = async () => {
    let data = await SaveExtra('Get_By_Type', 'AssesmentSuggestions', '', '')
    data = JSON.parse(data.d)?.Data || []

    if (data) {
      data = data.map((item) => ({
        Id: item.Id,
        Data: JSON.parse(item?.JsonData),
      }))
    }

    const findAssessmentSuggestionForDiagnosis = data.find((item) => item?.Data?.diagnosis?.label === diagnosisName)
    setSugesstionsAssessmentsList(findAssessmentSuggestionForDiagnosis?.Data?.accordions)
  }

  useEffect(() => {
    getAllDiagnosisDifferential()
  }, [])

  const renderNestedAccordions = (accordions) => {
    return (
      <CAccordion>
        {accordions
          .filter((accordion) => accordion.title)
          .map((accordion, index) => {
            return (
              <CAccordionItem itemKey={accordion.id || index} key={accordion.id || index}>
                <CAccordionHeader>
                  <div className="gap-2 d-flex align-items-center">
                    {accordion?.description && accordion?.description !== '' && (
                      <CTooltip content={accordion?.description ? accordion?.description : 'Add the tooltip'}>
                        <Info strokeWidth={1} size={16} />
                      </CTooltip>
                    )}
                    {accordion.title}
                  </div>
                </CAccordionHeader>
                <CAccordionBody>
                  {accordion.children && accordion.children.length > 0 ? (
                    renderNestedAccordions(accordion.children)
                  ) : (
                    <>
                      {accordion.suggestions?.suggestionName?.map((item, idx) => {
                        return (
                          <div className="d-flex align-items-center gap-2 justify-content-between">
                            <CFormCheck
                              checked={selectedAssessmentSuggestionStrings.includes(item.name)}
                              onChange={(e) => {
                                const isAlreadySelected = selectedAssessmentSuggestionStrings.includes(item.name)

                                if (isAlreadySelected) {
                                  // Remove from all three states
                                  setSelectedAssessmentSuggestionString((prev) => prev.filter((s) => s !== item.name))
                                  setSelectedPlanSuggestion((prev) => prev.filter((s) => s.name !== item.name))
                                } else {
                                  // Add to selectedAssessmentSuggestion
                                  setSelectedAssessmentSuggestionString((prev) => [...prev, item.name])

                                  // Extract plan suggestions
                                  const planSuggestions = accordion?.suggestions?.planSuggestions

                                  const matchingPlan = planSuggestions?.find((plan) => plan.name === item?.name)

                                  const flatSuggestionNames = matchingPlan?.accordions?.flatMap((acc) => acc?.suggestions?.suggestionName || []) || []

                                  const itemStructure = {
                                    name: item?.name,
                                    suggestions: flatSuggestionNames,
                                    description: item?.description || '',
                                  }

                                  setSelectedPlanSuggestion((prev) => [...prev, itemStructure])
                                }
                              }}
                              key={idx}
                              id={`suggestion-${accordion.id}-${idx}`}
                              label={item.name}
                            />
                          </div>
                        )
                      })}
                    </>
                  )}
                </CAccordionBody>
              </CAccordionItem>
            )
          })}
      </CAccordion>
    )
  }

  const renderAccordions = () => {
    if (sugesstionsAssessmentsList?.length) {
      return renderNestedAccordions(sugesstionsAssessmentsList)
    }
    return null
  }

  useEffect(() => {
    setAssessmentFinalValue(selectedAssessmentSuggestionStrings.join('\n'))
  }, [selectedAssessmentSuggestionStrings])

  const handleSubmitModal = () => {
    noteStructureRef.current = {
      ...noteStructureRef.current,
      assessment: {
        ...noteStructureRef.current.assessment,
        [diagnosisName]: {
          ...noteStructureRef.current.assessment[diagnosisName],
          assessmentSuggestions: assessmentFinalValue,
        },
      },
      plans: {
        ...noteStructureRef.current.plans,
        [diagnosisName]: {
          ...noteStructureRef.current.plans[diagnosisName],
          planSuggestion: selectedPlansSuggestionsStrings.join('\n'),
        },
      },
    }
    setAssessmentSuggestions(assessmentFinalValue)
    setVisible(false)
  }

  const labHtml =
  noteStructureRef?.current?.freeTypesEverything?.assessments?.[diagnosisName]?.LabImaging;

// function to check if HTML has real content
const hasValidContent = (html) => {
  if (!html) return false;

  const temp = document.createElement('div');
  temp.innerHTML = html;

  return temp.textContent.trim().length > 0;
};
  return (
    <div className="">
      {showTreatmentAsAccordion ? (
        <div className="m2">
          <div className="d-flex align-items-center gap-1">
            <h7>
              <b>Assessment</b>
            </h7>
          </div>
          <hr />

          {labsImaging && (
            <div className="mb-4">
              <label className="text-dark fw-semibold" style={{ fontSize: '14px' }}>
                Labs & Imaging
              </label>

              <div className=" mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                {labsImaging}
              </div>
            </div>
          )}

          {assessmentSuggestions && (
            <div className="mb-4">
              <label className="text-dark fw-semibold" style={{ fontSize: '14px' }}>
                Assessment Suggestions
              </label>

              <div className=" mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                {assessmentSuggestions}
              </div>
            </div>
          )}

          {freeType !== '' && (
            <div className="mb-4">
              <label className="text-dark fw-semibold" style={{ fontSize: '14px' }}>
                Free Type
              </label>

              <div className=" mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                {freeType}
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="m2">
          <div className="d-flex align-items-center gap-1">
            <h7>
              <b>Assessment</b>
            </h7>
          </div>
          <hr />
          {/* <div className="mb-4">
                <label className="text-dark fw-semibold" style={{ fontSize: "14px" }}>POA</label>
                <CFormTextarea
                    className="bg-secondary border rounded shadow-sm mt-2"
                    rows={3}
                    value={poa}
                    onChange={(e) => { handlePoaChange(e.target.value) }}
                />
            </div>

            <div className="mb-4">
                <label className="text-dark fw-semibold" style={{ fontSize: "14px" }}>Mobility Assessment</label>

                <div className="bg-secondary border rounded shadow-sm mt-2 p-2" style={{
                    minHeight: '43px'

                }}>
                    {mobilityData && questionFields.map((field) => {
                        const selected = mobilityData[field.key];
                        if (selected && selected.length > 0) {
                            const values = selected.map((item) => item.label).join(", ");
                            return (
                                <div key={field.key} className="" style={{ color: 'var(--ui-text-primary)', fontSize: '0.9rem', fontWeight: '400', fontFamily: 'Plus Jakarta Sans' }} >
                                    <strong >{field.label}:</strong> {values}
                                </div>
                            );
                        }
                        return null;
                    })}

                </div>
            </div>

            <div className="mb-4">
                <label className="text-dark fw-semibold" style={{ fontSize: "14px" }}>Morse Score</label>
                <CFormTextarea
                    className="bg-secondary border rounded shadow-sm mt-2"
                    rows={3}
                    disabled
                    value={total && morseScoreDate && `Morse Score: ${total}   recorded on Date: ${new Date(morseScoreDate).toLocaleDateString('en-US')}`}

                />
            </div> */}

          <div className="mb-4">
            <label className="text-dark fw-semibold" style={{ fontSize: '14px' }}>
              Labs & Imaging
            </label>

            {/* {noteStructureRef?.current?.freeTypesEverything?.assessments?.[diagnosisName]?.LabImaging && (
              <div className="my-2">
                <div
                  onClick={() => {
                    setTempHtmlContent(noteStructureRef?.current?.freeTypesEverything?.assessments?.[diagnosisName]?.LabImaging)
                    setShowEditHtml(true)
                  }}
                  className="p-4"
                  style={{ background: '#f6f6f6ff', borderRadius: '10px', cursor: 'text' }}
                  dangerouslySetInnerHTML={{ __html: noteStructureRef?.current?.freeTypesEverything?.assessments?.[diagnosisName]?.LabImaging }}
                ></div>
              </div>
            )} */}
              {hasValidContent(labHtml) && (
                <div className="my-2">
                  <div
                    className="p-2 patient-theme-old-data patient-theme-old-data--readonly patient-theme-old-data--final-note"
                    dangerouslySetInnerHTML={{ __html: labHtml }}
                  ></div>
                </div>
              )}
            <CFormTextarea className="bg-secondary border rounded shadow-sm mt-2" rows={3} value={labsImaging} onChange={(e) => handleLabsChanges(e.target.value)} />
          </div>

          <div className="mb-4">
            <div className="d-flex align-items-center gap-1">
              <label className="text-dark fw-semibold" style={{ fontSize: '14px' }}>
                Assessment Suggestions
              </label>
              {isAllotedToProvider && (
                <CFormLabel
                  className="patient-note-action d-flex mt-2 flex-column align-items-center justify-content-center shadow"
                  onClick={() => setVisible((p) => !p)}
                  style={{
                    width: '30px',
                    height: '30px',
                    borderRadius: '20px',
                    background: 'var(--ui-color-primary, #2b7cd3)',
                    cursor: 'pointer',
                  }}
                >
                  <Plus className="patient-note-action-icon" strokeWidth={2} size={15} />
                </CFormLabel>
              )}
            </div>
            <CFormTextarea className="bg-secondary border rounded shadow-sm mt-2" rows={3} value={assessmentSuggestions} disabled />
          </div>

          <div className="mb-2">
            <label className="text-dark fw-semibold" style={{ fontSize: '14px' }}>
              Free Type
            </label>
            <Graytextarea rows={5} height="20px" onClick={() => setVisibleModalTempFreeType((p) => !p)} value={freeType} />
          </div>
        </div>
      )}
      <CModal className="modal-assessment" visible={visible} onClose={() => setVisible(false)} aria-labelledby="ToggleBetweenModalsExample1">
        <CModalBody>
          <CNav className="d-flex align-items-center gap-2" variant="pills">
            <CNavItem className="">
              <CNavLink active={activeKey === 1} onClick={() => setActiveKey(1)} style={{ cursor: 'pointer' }}>
                Suggestion
              </CNavLink>
            </CNavItem>
            <CNavItem className="">
              <CNavLink active={activeKey === 2} onClick={() => setActiveKey(2)} style={{ cursor: 'pointer' }}>
                Assessment
              </CNavLink>
            </CNavItem>
          </CNav>
          <CTabContent>
            <CTabPane role="tabpanel" aria-labelledby="home-tab" className="mt-2" visible={activeKey === 1}>
              <CContainer className="p-0 border m-0">
                <CRow>
                  <CCol
                    style={{
                      width: sugesstionsAssessmentsList?.length > 0 ? '50%' : '100%',
                      overflowY: 'scroll',
                      height: '80vh',
                      borderRight: '1px solid #e2e2e2',
                    }}
                    className={``}
                  >
                    <div>{sugesstionsAssessmentsList?.length > 0 ? renderAccordions() : <p className="">No Assesment Suggestions</p>}</div>
                  </CCol>

                  <CCol
                    style={{
                      width: '50%',
                      overflowY: 'scroll',
                      height: '80vh',
                    }}
                    className="w-50"
                  >
                    {selectedPlanSuggestion.map((item, idx) => {
                      return (
                        <CAccordion flush>
                          <CAccordionItem itemKey={1}>
                            <CAccordionHeader className="" style={{ fontSize: '10px' }}>
                              <div className="d-flex align-items-center gap-2">
                                {item?.description && item?.description !== '' && (
                                  <CTooltip content={item?.description ? item?.description : 'Add the tooltip'}>
                                    <Info strokeWidth={1} size={16} />
                                  </CTooltip>
                                )}
                                {item.name}
                              </div>
                            </CAccordionHeader>
                            <CAccordionBody>
                              <div>
                                {item.suggestions.length > 0 &&
                                  item.suggestions &&
                                  item.suggestions.map((listItem, idx) => {
                                    return (
                                      <CFormCheck
                                        onChange={() => {
                                          if (selectedPlansSuggestionsStrings.length > 0 && selectedPlansSuggestionsStrings.includes(listItem.name)) {
                                            setSelectedPlanSuggestionsStrings((prev) => prev.filter((s) => s !== listItem.name))
                                          } else {
                                            setSelectedPlanSuggestionsStrings((prev) => [...prev, listItem.name])
                                          }
                                        }}
                                        id={listItem.name}
                                        checked={selectedPlansSuggestionsStrings.length > 0 && selectedPlansSuggestionsStrings.includes(listItem.name)}
                                        label={listItem?.name}
                                      />
                                    )
                                  })}
                              </div>
                            </CAccordionBody>
                          </CAccordionItem>
                        </CAccordion>
                      )
                    })}
                  </CCol>
                </CRow>
              </CContainer>
            </CTabPane>
            <CTabPane role="tabpanel" aria-labelledby="home-tab" className="mt-2" visible={activeKey2 === 2}>
              <Graytextarea onChange={(e) => setAssessmentFinalValue(e.target.value)} value={assessmentFinalValue} />
            </CTabPane>
          </CTabContent>
        </CModalBody>
        <CModalFooter>
          <CButton
            onClick={() => {
              setVisible(false)
              setSelectedPlanSuggestion([])
            }}
            color="secondary"
          >
            Close
          </CButton>
          <CButton
            onClick={() => {
              setSelectedPlanSuggestion([])
              setSelectedAssessmentSuggestionString([])
              setAssessmentFinalValue('')
              setSelectedPlanSuggestionsStrings([])
            }}
            color="secondary"
          >
            Clear All
          </CButton>
          <CButton disabled={sugesstionsAssessmentsList?.length === 0} onClick={handleSubmitModal}>
            Save Changes
          </CButton>
        </CModalFooter>
      </CModal>
      <CModal size="lg" backdrop="static" visible={orderModalVisible} onClose={() => setOrderModalVisible(false)} aria-labelledby="StaticBackdropExampleLabel">
        <AddOrders
          patientID={patientID}
          noteID={noteID}
          diagnosisName={diagnosisName}
          toggleModal={() => {
            setOrderModalVisible((p) => !p)
            setActiveKey2(1)
          }}
          fetchOrdersAgain={() => {}}
        />
      </CModal>

      {/* freetype modal */}
      <CModal backdrop="static" visible={visibleModalTempFreeType} onClose={() => setVisibleModalTempFreeType(false)} aria-labelledby="LiveDemoExampleLabel">
        <CModalHeader>
          <CModalTitle id="LiveDemoExampleLabel">Add Assessment Freetype</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <BulletTextArea placeholder="Enter freetype" value={tempFreeType} rows={4} onChange={(e) => setTempFreeType(e.target.value)} />
        </CModalBody>
        <CModalFooter>
          <CButton variant="outline" color="secondary" onClick={() => setVisibleModalTempFreeType(false)}>
            Close
          </CButton>
          <CButton color="primary" onClick={handleSaveFreetype} >
            Save Changes
          </CButton>
        </CModalFooter>
      </CModal>

      <CModal size="lg" visible={showEditHtml} onClose={() => setShowEditHtml(false)} aria-labelledby="OptionalSizesExample2">
        <CModalHeader>
          <CModalTitle id="OptionalSizesExample2">Edit Morse Score Free Type</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <Editor
            onChange={(e) => {
              setTempHtmlContent(e.target.value)
            }}
            containerProps={{
              style: {
                width: '100%',
                background: '#f9f9f9',
                border: 0,
                height: '100%',
                minHeight: 'unset',
              },
            }}
            value={tempHtmlContent}
          >
            <tooltip />
          </Editor>
        </CModalBody>
        <CModalFooter>
          <CButton variant="outline" color="secondary" onClick={() => setShowEditHtml(false)}>
            Close
          </CButton>
          <CButton
            variant="outline"
            color="primary"
            onClick={() => {
              noteStructureRef.current = {
                ...noteStructureRef.current,
                freeTypesEverything: {
                  ...noteStructureRef.current?.freeTypesEverything,
                  assessments: {
                    ...noteStructureRef.current?.freeTypesEverything?.assessments,
                    [diagnosisName]: {
                      ...noteStructureRef.current?.freeTypesEverything?.assessments?.[diagnosisName],
                      LabImaging: tempHtmlContent,
                    },
                  },
                },
              }
              saveTreatsShell(false)
              setShowEditHtml(false)
            }}
          >
            Save Changes
          </CButton>
        </CModalFooter>
      </CModal>
    </div>
  )
}

export default FallsAssessment
